'use client';
import { useContext } from 'react';
import { ChartCanvasContext } from 'react-financial-charts';
import type { StockData } from '../types/chart';

/** xAccessor 타입 (ChartCanvasContext에서 제공하는 xAccessor는 number | Date를 반환) */
export type XAccessor = (d: unknown) => number | Date;

/**
 * hook for getting candle data from ChartCanvasContext
 * only used in ChartCanvas children components
 *
 * @returns fullData(entire candle data), plotData (candles to be rendered), xAccessor
 */
export const useCandleData = () => {
  const context = useContext(ChartCanvasContext);

  if (!context) {
    console.warn('useCandleData must be used within ChartCanvas');
    return {
      fullData: [] as StockData[],
      plotData: [] as StockData[],
      xAccessor: ((_d: unknown) => 0) as XAccessor,
    };
  }

  const { fullData, plotData, xAccessor } = context;

  return {
    fullData: fullData as StockData[], // eslint-disable-line @typescript-eslint/no-unsafe-type-assertion
    plotData: plotData as StockData[], // eslint-disable-line @typescript-eslint/no-unsafe-type-assertion
    xAccessor: xAccessor as XAccessor,
  };
};
